import * as types from "../constants/action_types";
import Api from "../api";

function fetchedUser(user) {
  return { type: types.FETCH_USER, user };
}

function updatedUser(user) {
  return { type: types.UPDATE_USER, user };
}

function updateInvestments(investments) {
  return { type: types.UPDATE_INVESTMENTS, investments };
}

function updateCareers(careers) {
  return { type: types.UPDATE_CAREERS, careers };
}

function updateTwitterLink(twitter) {
  return { type: types.UPDATE_TWITTER_LINK, twitter };
}

export function fetchUser(name) {
  return function(dispatch) {
    return Api.showUser(name).then(response => {
      dispatch(fetchedUser(response));
    }).catch(error => {
      throw(error);
    });
  };
}

export function updateUser(data) {
  return function(dispatch) {
    return Api.updateUser(data).then(response => {
      dispatch(updatedUser(response));
    }).catch(error => {
      throw(error);
    });
  };
}

export function addInvestment(data) {
  return function(dispatch) {
    return Api.addInvestment(data).then(response => {
      dispatch(updateInvestments(response));
    }).catch(error => {
      throw(error);
    });
  };
}

export function deleteInvestment(id) {
  return function(dispatch) {
    return Api.deleteInvestment(id).then(response => {
      dispatch(updateInvestments(response));
    }).catch(error => {
      throw(error);
    });
  };
}

export function addCareer(data) {
  return function(dispatch) {
    return Api.addCareer(data).then(response => {
      dispatch(updateCareers(response));
    }).catch(error => {
      throw(error);
    });
  };
}

export function updateCareer(data) {
  return function(dispatch) {
    return Api.updateCareer(data).then(response => {
      dispatch(updateCareers(response));
    }).catch(error => {
      throw(error);
    });
  };
}

export function deleteCareer(data) {
  return function(dispatch) {
    return Api.deleteCareer(data).then(response => {
      dispatch(updateCareers(response));
    }).catch(error => {
      throw(error);
    });
  };
}

export function postTwitterCallback(data) {
  return function(dispatch) {
    return Api.postTwitterCallback(data).then(response => {
      dispatch(updateTwitterLink(response));
    }).catch(error => {
      throw(error);
    });
  };
}

export function deleteTwitterLink() {
  return function(dispatch) {
    return Api.deleteTwitterLink().then(response => {
      dispatch(updateTwitterLink(response));
    }).catch(error => {
      throw(error);
    });
  };
}
